import React from 'react'
import {
    Col,
    Row,
    Card,
    Button,
    Dialog,
    Divider
} from '../../Elements'
import { Classes, H5, Intent, H6 } from '@blueprintjs/core'

export const CriticalNoteDialog = ({ criticalNotesData = [], isOpen, onClose }) => {
    if (!Array.isArray(criticalNotesData)) {
        criticalNotesData = [criticalNotesData]
    }
    const titleText = criticalNotesData?.length === 1
        ? `This Job contains a Critical Note`
        : `This Job contains ${criticalNotesData?.length} Critical Notes`

    return (
        <Dialog
            icon='warning-sign'
            title='Critical Note'
            isOpen={isOpen}
            canOutsideClickClose={false}
            canEscapeKeyClose={false}
            isCloseButtonShown={false}
        >
            <div className={Classes.DIALOG_BODY}>
                <H5>{titleText}</H5>
                <Card>
                    {criticalNotesData && criticalNotesData.map((n, idx) =>
                        <>
                            <Row>
                                <Col xs={6}>
                                    {n.identifier_text}
                                </Col>
                                <Col xs={6}>
                                    <p style={{ maxHeight: '6em', overflow: 'auto' }}>{n.critical_note}</p>
                                </Col>
                            </Row>
                            {idx !== criticalNotesData.length - 1 && <Divider />}
                        </>
                    )}
                </Card>
            </div>

            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS} style={{ textAlign: 'center', display: 'block', marginRight: '10px' }}>
                    <Button
                        icon='issue-closed'
                        intent={Intent.WARNING}
                        text='Ok'
                        onClick={onClose} />
                </div>
            </div>
        </Dialog>
    )
}

export const convertJobDetailToCriticalNoteData = (jobDetail) => ({
    identifier_text: _getCriticalNoteSubjobIdentifier(jobDetail),
    category: jobDetail.job_category.name,
    critical_note: jobDetail.critical_note
})

const _getCriticalNoteSubjobIdentifier = (sub_job) => {
    const job_types = sub_job?.job_types?.map(j => j.name).join(', ')

    const date = sub_job.job_category.id === 1
        ? sub_job.gunite_details?.finished_date
        : sub_job.job_category.id === 2
            ? sub_job.pebble_details?.app_date
            : null

    return <span>
        {<H6>{`(${sub_job.job_category.name})`}{date && <span> - {date}</span>}</H6>}
        {job_types && <p style={{ maxHeight: '4.2em', overflow: 'auto' }}>{job_types}</p>}
    </span>
}